import { FC, ReactNode, useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from 'src/components/Footer';

interface SidebarLayoutProps {
  children?: ReactNode;
  isFicheDc?: boolean;
};

const containsText = (text: string, searchText: string) => {
  return text?.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
};

const MainWrapper = styled(Box)(
  ({ theme }) => `
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  `
);

const MainContent = styled(Box)(
  ({ theme }) => `
    margin-top: ${theme.header.height};
    flex: 1;
  `
);

const SidebarLayout: FC<SidebarLayoutProps> = ({ isFicheDc }) => {
  const [location, setLocation] = useState(useLocation().pathname);
  const [titleData, setTitleData] = useState<string>();

  useEffect(() => {
    if (containsText(location, 'dc/fiche')) {
      setTitleData("header.titleDc");
    } else if (containsText(location, 'ea/fiche')) {
      setTitleData("header.titleEa");
    } else {
      setTitleData(" ");
    }
  }, [location]);

  return (
    <>
      <MainWrapper>
        {titleData && (
          <Header
            headerAddon={titleData}
            isFicheDc={isFicheDc}
          />
        )}

        <MainContent>
          <Outlet />
        </MainContent>

        <Footer />
      </MainWrapper >
    </>
  );
};

export default SidebarLayout;
